import {
    INodeAction,
    IUseActionReturnType,
} from '@/features/drive/functionalities/actions/node/core/shared/utils/node-action-helpers'
import { useNodeItemContext } from '@/features/drive/entities/node/node-item-context'
import { NodeFavoriteActionStar } from '@/features/drive/functionalities/actions/node/core/node-favorite-action/node-favorite-action-star'
import { useMemo } from 'react'
import { useToggleNodeFavoriteMutation } from '@/api/nodes/mutations/toggle-node-favorite'
import { useDirectoryContext } from '@/features/drive/entities/directory/directory-context'
import { NodeType } from '@/api/nodes/mutations/directory/create-directory-mutation'

export const useNodeFavoriteAction = (): IUseActionReturnType => {
    const { node } = useNodeItemContext()

    const { toggleFavorite } = useNodeFavorite()

    const action: INodeAction = useMemo(() => {
        return {
            icon: NodeFavoriteActionStar,
            label: node.isUserFavorite ? 'Remove from favorites' : 'Add to favorites',
            call: () => toggleFavorite?.(),
            applicableForTypes: [NodeType.FILE, NodeType.DIRECTORY],
        }
    }, [node.isUserFavorite, toggleFavorite])

    return { action, nodes: <></> }
}

export const useNodeFavorite = () => {
    const { content } = useDirectoryContext()
    const { node } = useNodeItemContext()

    const { mutateAsync: toggleNodeFavoriteAsync } = useToggleNodeFavoriteMutation({
        nodeContentQueryKey: content.nodeContentQueryKey,
    })

    const toggleFavorite = useMemo(() => {
        if (!node.uuid || node.systemNode) return null

        return () => {
            return toggleNodeFavoriteAsync({ node })
        }
    }, [node, toggleNodeFavoriteAsync])

    return { toggleFavorite }
}
